import {
  useTheme,
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { ClearRounded } from "@mui/icons-material";

const MainInput = ({
  value,
  onChange,
  onClear = null,
  placeholder = "Enter your value ...",
  sx = {},
  InputProps = {},
  sxWrapper = {},
  ...props
}) => {
  const theme = useTheme();
  return (
    <Box className="container-card">
      <Box
        className="square"
        sx={{
          height: "100%",
          width: { xs: "100%", sm: "70%" },
          px: 3,
          pt: 2.5,
          pb: 2,
          boxShadow: theme.palette.squareBoxShadow,
          zIndex: 1,
          borderRadius: "50px",
          border: theme.palette.tinyBorder,
          ...sxWrapper,
        }}
      >
        <TextField
          fullWidth
          multiline
          maxRows={7}
          type="text"
          variant="standard"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          InputProps={{
            disableUnderline: true,
            endAdornment: value && onClear && (
              <InputAdornment position="end">
                <IconButton onClick={onClear} edge="end">
                  <ClearRounded fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
            ...InputProps,
          }}
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "17px",
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor:
                  theme.palette.mode === "light" ? "#c1c1c1" : "#6b6b6b",
                borderRadius: "4px",
                cursor: "grab",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor:
                  theme.palette.mode === "light"
                    ? "#F0F0F0"
                    : theme.palette.background.paper,
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb:active": {
                cursor: "grabbing",
              },
            },
            ...sx,
          }}
          {...props}
        />
      </Box>
    </Box>
  );
};

export default MainInput;
